import React from 'react';
import PropTypes from 'prop-types';

const textAreaStyle = {
  overflowY: 'auto',
  lineHeight: '1.3',
  fontSize: '14px',
  letterSpacing: '0.01em',
  width: '100%'
};

const NotesArea = ({
  noteMarkup,
  containerHeight = '650px'
}) => {
  return (
    <div
      style={{ height: containerHeight, ...textAreaStyle }}
      id="encounter-text-area"
      dangerouslySetInnerHTML={{ __html: noteMarkup }}
    />
  );
};

NotesArea.propTypes = {
  containerHeight: PropTypes.string.isRequired,
  noteMarkup: PropTypes.string.isRequired
};

export default NotesArea;
